module.exports = __webpack_public_path__ + "img/pr-19.272653e2.png";